import { ApprovalDetailsRequestModel } from './approvalDetailsRequestModel';

export class SoApprovalCycleRequestModel{
    code : string;
    sitesId : number[];
    isEnable : boolean;
    customerIds : number[];
    soApprovalDetails : ApprovalDetailsRequestModel[];
}